<template>
  <form @submit.prevent>
    <div>
      <b-tabs v-if="showLibraryItems" justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
        <b-tab :active="showLibraryItems">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <span class="d-none d-sm-inline-block">{{ $t("common.library") }}</span>
          </template>
          <!--           
          <div class="pl-5 pr-5">
            <recommendation-items
              rightPanelId="sidebar-department-recommendation"
              level="department"
              libraryScopedState="department"
              organizationScopedState="organizationDepartment"
            />
          </div> -->

          <LibraryItems
            rightPanelId="sidebar-new-department"
            organizationScopedState="organizationDepartment"
            libraryScopedState="department"
            libraryScopedStateCategory="departmentCategory"
          />
        </b-tab>

        <b-tab :active="isEditMode">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="far fa-user"></i>
            </span>
            <span class="d-none d-sm-inline-block">
              <span v-if="isEditMode">{{ $t("common.update") }}</span>
              <span v-else>{{ $t("department.new") }}</span>
            </span>
          </template>

          <sweet-input
            :isValid="!$v.form.name.$error"
            @input="$v.form.name.$touch()"
            v-model="form.name"
            type="text"
            layout="vertical"
            :placeholder="$t('department.name')"
            :label="$t('department.name')"
          />

          <div class="col-mr-5 mt-3">
            <right-panel
              class="float-right mt-1 "
              id="sidebar-new-department-category"
              width="650px"
              :icon="'mdi mdi-plus'"
              :text="$t('department-category.new')"
              @hidden="rightPanelClosed"
            >
              <div class="pl-5 pr-5">
                <Form :hide-library="true" @onSave="onFormSave" />
              </div>
            </right-panel>
          </div>

          <h6 class="mt-4">{{ $t("department-category.text") }}</h6>
          <filter-select
            id="categoryFilter"
            ref="categoryFilter"
            :placeholder="$t('department-category.text')"
            :multiple="false"
            @filter="onCategorySearch"
            :selected="form.category"
            @changed="onCategorySelect"
          />

          <h6 class="mt-4">{{ $t("department.admin") }}</h6>

          <organization-member-select @onAclSelect="onDepartmentAdminSelect" />
          <!-- :permissionFilter="['ORGANIZATION_ADMIN']" -->

          <h6 class="mt-4">{{ $t("unit.text") }}</h6>
          <filter-select id="unitFilter" ref="unitFilter" :placeholder="$t('unit.text')" :multiple="false" @filter="onSearch" :selected="form.unit" @changed="onSelect" />

          <sweet-button
            @click="save()"
            type="submit"
            :loading="isUpdating"
            :disabled="isUpdating || $v.$invalid"
            variant="success"
            icon="mdi mdi-check"
            size="sm"
            buttonClass="mt-2"
          >
            {{ $t("common.save") }}
          </sweet-button>
        </b-tab>
      </b-tabs>
      <div v-else>
        <h2>
          <span v-if="!showLibraryItems && isEditMode">{{ entityName }} {{ $t("common.update") }}</span>
          <span v-else>{{ $t("department.new") }}</span>
        </h2>

        <sweet-input
          :isValid="!$v.form.name.$error"
          @input="$v.form.name.$touch()"
          v-model="form.name"
          type="text"
          layout="vertical"
          :placeholder="$t('department.name')"
          :label="$t('department.name')"
        />

        <h6 class="mt-4 d-inline-block">{{ $t("department-category.text") }}</h6>

        <right-panel
          class="float-right d-inline-block mt-4"
          id="sidebar-new-department-category"
          backdrop-variant="dark"
          width="650px"
          :icon="'mdi mdi-plus'"
          :text="$t('department-category.new')"
          @hidden="rightPanelClosed"
        >
          <div class="pl-5 pr-5">
            <Form :hide-library="true" @onSave="onFormSave" />
          </div>
        </right-panel>

        <filter-select
          id="categoryFilterq"
          ref="categoryFilterq"
          :placeholder="$t('department-category.text')"
          :multiple="false"
          @filter="onCategorySearch"
          :selected="form.category"
          @changed="onCategorySelect"
        />

        <h6 class="mt-4">{{ $t("department.admin") }}</h6>

        <organization-member-select @onAclSelect="onDepartmentAdminSelect" :selected="admin" />
        <!-- :permissionFilter="['ORGANIZATION_ADMIN']"  -->

        <h6 class="mt-4">{{ $t("unit.text") }}</h6>

        <filter-select
          openDirection="top"
          id="unitFilter1"
          ref="unitFilter1"
          :placeholder="$t('unit.text')"
          :multiple="false"
          @filter="onSearch"
          :selected="form.unit"
          @changed="onSelect"
        />

        <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
          {{ $t("common.save") }}
        </sweet-button>

        <sweet-button @click="cancel()" variant="secondary" icon="mdi mdi-cancel" size="sm" buttonClass="mt-2 ml-2">
          {{ $t("common.cancel") }}
        </sweet-button>
        <hr />
      </div>
    </div>
  </form>
</template>

<script>
import LibraryItems from "@cc/library-items";
import OrganizationMemberSelect from "@cc/organization-member-select";
import RecommendationItems from "@cc/recommendation-items";
import Form from "./organization-department-category-form.vue";

import { maxLength, minLength, required } from "vuelidate/lib/validators";

export default {
  props: { "hide-library": { type: Boolean }, closeOnSave: { type: Boolean, default: true } },
  components: {
    LibraryItems,
    RecommendationItems,
    Form,
    RecommendationItems,
    OrganizationMemberSelect,
  },
  data() {
    return {
      form: { name: undefined, category: undefined, admins: undefined, unit: undefined },
      formError: undefined,
      entityName: undefined,
      adminChanged: false,
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },
      category: {
        required,
      },
      admins: {
        required,
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        if (!v || Object.keys(v).length === 0) return;

        this.form = { ...this.prepareFormForEdit(v) };
        this.entityName = this.form.name;
      },
    },
    copingEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        if (!v || Object.keys(v).length === 0) return;

        this.form = { ...this.prepareFormForEdit(v) };
        this.entityName = this.form.name;
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters["organizationDepartment/isUpdating"];
    },
    admin() {
      if (this.form.admins?.length == 0) {
        return undefined;
      }
      if (this.form.admins && this.form.admins[0].account) {
        return this.form.admins[0].account;
      } else if (this.form._id) {
        return {
          _id: this.form.admins[0].accountId,
          name: this.form.admins[0].name,
          email: this.form.admins[0].email,
          avatar: this.form.admins[0].avatar,
        };
      }
    },
    editedEntity() {
      return this.$store.getters["organizationDepartment/editedEntity"];
    },
    copingEntity() {
      return this.$store.getters["organizationDepartment/copingEntity"];
    },
    isEditMode() {
      return this.$store.getters["organizationDepartment/isEditMode"];
    },
    showLibraryItems() {
      return !this.hideLibrary && !this.isEditMode && !this.isCoping;
    },
    isCoping() {
      return this.$store.getters["organizationDepartment/isCoping"];
    },
  },
  async mounted() {},
  methods: {
    async save() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        const { data } = await this.$store.dispatch("organizationDepartment/save", this.form);
        this.$store.commit("organizationDepartment/editedEntity", data);
        this.$emit("onDepartmentSave");
        this.adminChanged && this.$emit("onAdminChanged");
        if (this.closeOnSave) {
          this.$root.$emit("bv::toggle::collapse", "sidebar-new-department");
        }
        setTimeout(() => {
          this.resetForm();
        }, 500);

        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    resetForm() {
      this.form = {
        name: undefined,
        category: undefined,
        admins: undefined,
        unit: undefined,
      };
    },
    cancel() {
      this.$store.commit("organizationDepartment/editedEntity");
      this.$store.commit("organizationDepartment/copingEntity");
      // this.$store.dispatch("organizationDepartment/resetForm");
    },
    async onSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationUnit/paginate`, {
        options: { limit: 20 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onSelect(item) {
      this.form = { ...this.form, unit: item };
    },

    rightPanelClosed() {
      if (this.$refs.categoryFilter) {
        this.$refs.categoryFilter.reset();
      }
    },

    async onCategorySearch(value, callback) {
      const response = await this.$store.dispatch(`departmentCategory/paginate`, {
        options: { limit: 20 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onDepartmentAdminSelect(item) {
      this.form = { ...this.form, admins: [item] };
      this.adminChanged = true;
    },
    onFormSave(item) {
      this.form = { ...this.form, category: { ...item, _id: item.libraryItem } };
    },
    onCategorySelect(item) {
      this.form = { ...this.form, category: item };
    },
  },
};
</script>
